module.exports = __webpack_public_path__ + "static/media/back-selected.879f3aaa.svg";